import { FeaturesAndBenefitsSlider } from '@latitude/features-and-benefits-slider';

export default FeaturesAndBenefitsSlider;
